export const CREATE_VISUALIZATIONS_SUBSCRIPTION =
  'dt/visualizations/CREATE_VISUALIZATIONS_SUBSCRIPTION';
export const DESTROY_VISUALIZATIONS_SUBSCRIPTION =
  'dt/visualizations/DESTROY_VISUALIZATIONS_SUBSCRIPTION';
export const GET_SINGLE_VISUALIZATION_DATA = 'dt/visualizations/GET_SINGLE_VISUALIZATION_DATA';
export const BULK_UPSERT_VISUALIZATION = 'dt/visualizations/BULK_UPSERT_VISUALIZATION';
export const UPSERT_VISUALIZATION = 'dt/visualizations/UPSERT_VISUALIZATION';
export const RESET_VISUALIZATION = 'dt/visualizations/RESET_VISUALIZATION';
export const REQUEST_DELETE_VISUALIZATION = 'dt/visualizations/REQUEST_DELETE_VISUALIZATION';
export const DELETE_VISUALIZATION_SUCCESS = 'dt/visualizations/DELETE_VISUALIZATION_SUCCESS';
export const REQUEST_VISUALIZATIONS = 'dt/visualizations/REQUEST_VISUALIZATIONS';
export const RECEIVE_VISUALIZATION = 'dt/visualizations/RECEIVE_VISUALIZATION';
export const RECEIVE_VISUALIZATIONS = 'dt/visualizations/RECEIVE_VISUALIZATIONS';
export const SAVE_VISUALIZATION = 'dt/visualizations/SAVE_VISUALIZATION';
export const VISUALIZATION_SAVED = 'dt/visualizations/VISUALIZATION_SAVED';
export const RECEIVED_VALUES = 'dt/visualizations/RECEIVED_VALUES';
export const INIT_VISUALIZATIONS = 'dt/visualizations/INIT_VISUALIZATIONS';
export const RESET_VISUALIZATIONS = 'dt/visualizations/RESET_VISUALIZATIONS';
export const SET_LOADING = 'dt/visualizations/SET_LOADING';

export const LAST_VALUE_VISUALIZATIONS = ['metric', 'gauge', 'bar-gauge', 'status', 'state'];

export const getSingleVisualization = (visualization, panelId) => ({
  type: GET_SINGLE_VISUALIZATION_DATA,
  visualization,
  panelId,
});

export const bulkUpsertVisualization = (visualization, siteId) => ({
  type: BULK_UPSERT_VISUALIZATION,
  visualization,
  siteId,
});

export const upsertVisualization = (siteId, visualization) => ({
  type: UPSERT_VISUALIZATION,
  siteId,
  visualization,
});

export const resetVisualization = (siteId) => ({
  type: RESET_VISUALIZATION,
  siteId,
});

export const saveVisualization = (visualization, parentPanelId) => ({
  type: SAVE_VISUALIZATION,
  visualization,
  parentPanelId,
});

export const requestVisualizations = (siteId) => ({
  type: REQUEST_VISUALIZATIONS,
  siteId,
});

export const requestDeleteVisualization = (visualizationId) => ({
  type: REQUEST_DELETE_VISUALIZATION,
  visualizationId,
});

export const deleteVisualizationSuccess = (visualizationId) => ({
  type: DELETE_VISUALIZATION_SUCCESS,
  visualizationId,
});

export const receiveVisualization = (visualization) => ({
  type: RECEIVE_VISUALIZATION,
  visualization,
});

export const receiveVisualizations = (visualizations, siteId) => ({
  type: RECEIVE_VISUALIZATIONS,
  visualizations,
  siteId,
});

export const layoutSaved = (siteId, layout, dateRange) => ({
  type: VISUALIZATION_SAVED,
  siteId,
  layout,
  dateRange,
});

export const subscribe = (visualizationId, panelId) => ({
  type: CREATE_VISUALIZATIONS_SUBSCRIPTION,
  visualizationId,
  panelId,
});

export const unsubscribe = (visualizationId, panelId) => ({
  type: DESTROY_VISUALIZATIONS_SUBSCRIPTION,
  visualizationId,
  panelId,
});

export const receivedValues = (visualizationId, values, panelId) => {
  const { latestValues, seriesValues } = values;
  return {
    type: RECEIVED_VALUES,
    visualizationId,
    latestValues,
    seriesValues,
    panelId,
  };
};

export const setLoading = (visualizationId, panelId, loading = true) => ({
  type: SET_LOADING,
  visualizationId,
  panelId,
  loading,
});

export const initVisualizations = () => ({
  type: INIT_VISUALIZATIONS,
});

export const resetVisualizations = () => ({
  type: RESET_VISUALIZATIONS,
});
